import { InfoIcon } from "lucide-react";
import { AppText } from "@/components/Text/AppText";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/Tooltip";

interface SideBarHeaderProps {
    title: string;
    isBeta?: boolean;
    betaMessage?: string;
}

export const SideBarHeader = ({
    title,
    isBeta = false,
    betaMessage,
}: SideBarHeaderProps) => {
    return (
        <div className="mx-4 flex items-center justify-between bg-white pb-4">
            <AppText variant="subheadings">{title}</AppText>
            {isBeta && (
                <Tooltip placement="bottom">
                    <TooltipTrigger>
                        <div className="flex items-center gap-2 rounded-lg bg-alert-800 px-2 py-1 shadow-md hover:bg-alert-900 ">
                            <InfoIcon className="h-4 w-4 text-neutral-100" />
                            <AppText
                                variant="footnote"
                                className="!font-semibold text-neutral-100"
                            >
                                BETA
                            </AppText>
                        </div>
                    </TooltipTrigger>
                    {betaMessage && (
                        <TooltipContent style={{ maxWidth: "230px" }}>
                            <AppText variant="regular">{betaMessage}</AppText>
                        </TooltipContent>
                    )}
                </Tooltip>
            )}
        </div>
    );
};
